import axios from "axios";

const backendEndpoint = process.env.REACT_APP_MACI_BACKEND_API_ENDPOINT;

const initialState = {
  clientConfig: {},
  callBotSimulationResult: null,
  alloBrainSimulationResult: null,
  flows: [],
  loadingFlowListApi: false,
  loadingSaveApi: false,
  loadingDeleteFlowApi: false,
  loadingPublishFlowApi: false,
  loadingSimulateFlowApi: false,
  loadingFlowStatusApi: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "load-client-fetch":
      return {
        ...state,
        clientConfig: action.config,
      };
    case "start-load-flow-status":
      return {
        ...state,
        loadingFlowStatusApi: true,
      };
    case "load-flow-status":
      return {
        ...state,
        lastCheckedFlowStatus: {
          id: action.flowId,
          isPublished: action.isPublished,
        },
      };
    case "stop-load-flow-status":
      return {
        ...state,
        loadingFlowStatusApi: false,
      };
    case "start-load-flow-list":
      return {
        ...state,
        loadingFlowListApi: true,
      };
    case "load-flow-list":
      return {
        ...state,
        flows: action.flows,
      };
    case "stop-load-flow-list":
      return {
        ...state,
        loadingFlowListApi: false,
      };
    case "start-load-save-flow":
      return {
        ...state,
        loadingSaveApi: true,
      };
    case "stop-load-save-flow":
      return {
        ...state,
        loadingSaveApi: false,
      };
    case "start-load-delete-flow":
      return {
        ...state,
        loadingDeleteFlowApi: true,
      };
    case "stop-load-delete-flow":
      return {
        ...state,
        loadingDeleteFlowApi: false,
      };
    case "start-loading-publish-flow-api":
      return {
        ...state,
        loadingPublishFlowApi: true,
      };
    case "stop-loading-publish-flow-api":
      return {
        ...state,
        loadingPublishFlowApi: false,
      };
    case "start-loading-simulate-flow-api":
      return {
        ...state,
        loadingSimulateFlowApi: true,
        simulationError: null,
        callBotSimulationResult: null,
        alloBrainSimulationResult: null,
      };
    case "load-call-bot-simulation":
      return {
        ...state,
        callBotSimulationResult: action.simulation,
      };
    case "load-allo-brain-simulation-store-id":
      return {
        ...state,
        alloBrainSimulationResult: action.simulation,
      };
    case "stop-loading-simulate-flow-api":
      return {
        ...state,
        loadingSimulateFlowApi: false,
      };
    case "loading-simulation-error":
      return {
        ...state,
        simulationError: action.error,
      };
    case "start-loading-simulate-allo-brain-store":
      return {
        ...state,
        //alloBrainSimulationResult: null,
        loadingAlloBrainStore: true,
      };
    case "load-allo-brain-simulation-store":
      return {
        ...state,
        alloBrainSimulationResult: {
          ...state.alloBrainSimulationResult,
          store: action.store,
        },
      };
    case "stop-loading-simulate-allo-brain-store":
      return {
        ...state,
        loadingAlloBrainStore: false,
      };
    case "update-flow-status":
      return {
        ...state,
        lastCheckedFlowStatus: {
          _id: action.flowId,
          isPublished: action.isPublished,
        },
      };
    case "start-loading-callbot-simulation-logs":
      return {
        ...state,
        loadingCallbotSimulationLogs: true,
      };
    case "load-callbot-simulation-logs":
      return {
        ...state,
        callbotSimulationLogs: action.logs,
      };
    case "stop-loading-callbot-simulation-logs":
      return {
        ...state,
        loadingCallbotSimulationLogs: false,
      };

    default:
      return initialState;
  }
};

/**
 *
 * @param method {string} GET or POST
 * @param endpoint {string} endpoint to call
 * @param params {object} params to send
 * @param data {object} data to send
 * @returns {Promise<unknown>} promise
 */
function fetchBackendApi(method, endpoint, params, data = {}) {
  return new Promise((resolve, reject) => {
    switch (method) {
      case "get":
        axios
          .get(endpoint, {
            params,
            headers: {
              Authorization: window.localStorage.getItem("token"),
            },
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
        break;
      case "post":
        axios
          .post(endpoint, data, {
            params,
            headers: {
              "Content-Type": "text/plain",
              Authorization: window.localStorage.getItem("token"),
            },
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
        break;
      case "delete":
        axios
          .delete(endpoint, {
            params,
            headers: {
              Authorization: window.localStorage.getItem("token"),
            },
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
        break;
      default:
        reject(new Error("Method not supported"));
    }
  });
}

const asyncActions = {
  "fetch-client-config":
    ({ dispatch }) =>
    async (action) => {
      dispatch({
        type: "load-client-fetch",
        config: await fetchBackendApi(
          "get",
          backendEndpoint + "client-config",
          {
            brand: action.brand,
            app: action.app,
          }
        ),
      });
    },
  "fetch-flow-list":
    ({ dispatch }) =>
    async (action) => {
      dispatch({
        type: "start-load-flow-list",
      });
      dispatch({
        type: "load-flow-list",
        flows: await fetchBackendApi("get", backendEndpoint + "flows", {
          app: action.app,
          brand: action.brand,
          name: action.flowName,
        }),
      });
      dispatch({
        type: "stop-load-flow-list",
      });
    },
  "fetch-save-flow":
    ({ dispatch }) =>
    async (action) => {
      dispatch({
        type: "start-load-save-flow",
      });
      try {
        const response = await fetchBackendApi(
          "post",
          backendEndpoint + "flows",
          {
            brand: action.brand,
            flowId: action.flowId,
            app: action.app,
          },
          action.flow
        );
        action.onSuccess(response.msg, response.upserted_id);
        dispatch({
          type: "stop-load-save-flow",
        });
      } catch (e) {
        const msg = e.response.data.message;
        action.onError(msg ? msg : "An error occurred");
        dispatch({
          type: "stop-load-save-flow",
        });
      }
    },
  "fetch-delete-flow":
    ({ dispatch }) =>
    async (action) => {
      dispatch({
        type: "start-load-delete-flow",
      });
      try {
        const response = await fetchBackendApi(
          "delete",
          backendEndpoint + "flows",
          {
            brand: action.brand,
            app: action.app,
            flowId: action.flowId,
          },
          action.flow
        );
        action.onSuccess(response.msg, response.upserted_id);
        dispatch({
          type: "stop-load-delete-flow",
        });
      } catch (e) {
        const msg = e.response.data.msg;
        action.onError(msg ? msg : "An error occurred");
        dispatch({
          type: "stop-load-delete-flow",
        });
      }
    },
  "fetch-flow-status":
    ({ dispatch }) =>
    async (action) => {
      dispatch({
        type: "start-load-flow-status",
      });
      try {
        const response = await fetchBackendApi(
          "get",
          backendEndpoint + "publish",
          {
            brand: action.brand,
            flowId: action.flowId,
            app: action.app,
            flowName: action.flowName,
          }
        );
        //action.onSuccess(response.msg, response.upserted_id);
        dispatch({
          type: "load-flow-status",
          isPublished: response.isPublished,
          flowId: action.flowId,
        });
        dispatch({
          type: "stop-load-flow-status",
        });
      } catch (e) {
        const msg = e.response.data.msg;
        // action.onError(msg ? msg : "An error occurred");
        dispatch({
          type: "stop-load-flow-status",
        });
      }
    },
  "fetch-publish-flow":
    ({ dispatch }) =>
    async (action) => {
      dispatch({
        type: "start-loading-publish-flow-api",
      });
      try {
        const response = await fetchBackendApi(
          "post",
          backendEndpoint + "publish",
          {
            brand: action.brand,
            flowName: action.flowName,
            flowId: action.flowId,
            version: action.version,
          },
          action.config
        );
        action.onSuccess(response.msg);
        dispatch({
          type: "stop-loading-publish-flow-api",
        });
        dispatch({
          type: "load-flow-status",
          isPublished: true,
          flowId: action.flowId,
        });
      } catch (e) {
        const msg = e.response.data.msg;
        action.onError(msg ? msg : "An error occurred");
        dispatch({
          type: "stop-loading-publish-flow-api",
        });
      }
    },
  "fetch-simulate-flow":
    ({ dispatch }) =>
    async (action) => {
      dispatch({
        type: "start-loading-simulate-flow-api",
      });
      try {
        let type = null;
        switch (action.app) {
          case "call-bot":
            type = "load-call-bot-simulation";
            break;
          case "allo-brain":
            type = "load-allo-brain-simulation-store-id";
            break;
          default:
            type = null;
        }
        try {
          dispatch({
            type,
            simulation: await fetchBackendApi(
              "post",
              (action.api_endpoint || backendEndpoint) + "simulation", // action_api_endpoint is used for custom callbot simiulation api
              action.queryParameters,
              action.config || action.body
            ),
          });
        } catch (e) {
          dispatch({
            type: "loading-simulation-error",
            error: e.response.data || e,
          });
        }

        //action.onSuccess(response.msg)
        dispatch({
          type: "stop-loading-simulate-flow-api",
        });
      } catch (e) {
        const msg = e.message;
        if (action.onError instanceof Function) {
          action.onError(msg ? msg : "An error occurred");
        }

        dispatch({
          type: "stop-loading-simulate-flow-api",
        });
      }
    },
  "fetch-allo-brain-simulate-store":
    ({ dispatch }) =>
    async (action) => {
      dispatch({
        type: "start-loading-simulate-allo-brain-store",
      });
      try {
        dispatch({
          type: "load-allo-brain-simulation-store",
          store: await fetchBackendApi(
            "get",
            backendEndpoint + "allo-brain-logs",
            action.queryParameters
          ),
        });

        //action.onSuccess(response.msg)
        dispatch({
          type: "stop-loading-simulate-allo-brain-store",
        });
      } catch (e) {
        const msg = e.message;
        if (action.onError instanceof Function) {
          action.onError(msg ? msg : "An error occurred");
        }

        dispatch({
          type: "stop-loading-simulate-allo-brain-store",
        });
      }
    },
  "fetch-callbot-simulation-logs":
    ({ dispatch }) =>
    async (action) => {
      dispatch({
        type: "start-loading-callbot-simulation-logs",
      });
      try {
        dispatch({
          type: "load-callbot-simulation-logs",
          logs: await fetchBackendApi(
            "get",
            backendEndpoint + "simulation/callbot_logs",
            action.queryParameters
          ),
        });

        //action.onSuccess(response.msg)
        dispatch({
          type: "stop-loading-callbot-simulation-logs",
        });
      } catch (e) {
        const msg = e.message;
        if (action.onError instanceof Function) {
          action.onError(msg ? msg : "An error occurred");
        }

        dispatch({
          type: "stop-loading-callbot-simulation-logs",
        });
      }
    },
};

export {
  reducer,
  initialState,
  asyncActions,
  backendEndpoint,
  fetchBackendApi,
};
